import { useEffect } from 'react';
export default function (fn, input) {
    useEffect(fn, [input]);
}
